import { PostFormState } from "../postFormSlice.types";

export const checkIsFilled = (state: PostFormState) => {
    if (
        state.autoFilled &&
        state.characteristicsFilled &&
        state.photoFilled &&
        state.descriptionFilled &&
        state.contactsFilled &&
        state.placeFilled &&
        state.priceFilled
    ) {
        return true;
    }
    return false;
};